/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateClientRequest
 */
export interface CreateClientRequest {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    location: string;
    /**
     * Use upper range
     */
    employeeCount: number;
    /**
     * 
     */
    billingCycle: string;
    /**
     * 
     */
    mode: string;
    /**
     * NFR domains are free of charge
     */
    internalAd: boolean;
    /**
     * Service provider internal client identifier
     */
    clientRef?: string | null;
}

/**
 * Check if a given object implements the CreateClientRequest interface.
 */
export function instanceOfCreateClientRequest(value: object): value is CreateClientRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('employeeCount' in value) || value['employeeCount'] === undefined) return false;
    if (!('billingCycle' in value) || value['billingCycle'] === undefined) return false;
    if (!('mode' in value) || value['mode'] === undefined) return false;
    if (!('internalAd' in value) || value['internalAd'] === undefined) return false;
    return true;
}

export function CreateClientRequestFromJSON(json: any): CreateClientRequest {
    return CreateClientRequestFromJSONTyped(json, false);
}

export function CreateClientRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClientRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'location': json['location'],
        'employeeCount': json['employeeCount'],
        'billingCycle': json['billingCycle'],
        'mode': json['mode'],
        'internalAd': json['internalAd'],
        'clientRef': json['clientRef'] === undefined ? undefined : json['clientRef'] === null ? null : json['clientRef'],
    };
}

export function CreateClientRequestToJSON(json: any): CreateClientRequest {
    return CreateClientRequestToJSONTyped(json, false);
}

export function CreateClientRequestToJSONTyped(value?: CreateClientRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'location': value['location'],
        'employeeCount': value['employeeCount'],
        'billingCycle': value['billingCycle'],
        'mode': value['mode'],
        'internalAd': value['internalAd'],
        'clientRef': value['clientRef'],
    };
}

